module.exports = __webpack_public_path__ + "img/b0309_10.ef8f4517.png";